import { useTranslation } from 'react-i18next';
import { Role } from '@delmonicos/shared-sdk/libs/emsp/src/libs/back-office/src/back-office.enums';

type RoleTextHookReturn = (role?: Role) => string;

export function useGetRole(): RoleTextHookReturn {
  const { t } = useTranslation();

  return (role?: Role) =>
    t([`model.enum.role.${role}`, 'model.enum.role.unknown']);
}
